module.exports = __webpack_public_path__ + "img/cover-henk.b6c84897.png";